import classNames from "classnames";
import Link from "next/link";
import React, { PropsWithChildren } from "react";

import styles from "./Pill.module.css";

type PropTypes = {
  color: string;
  circle?: boolean;
  size?: "sm" | "md" | "lg";
  className: string;
  href: string;
};

const Pill: React.FC<PropsWithChildren<PropTypes>> = ({
  size = "sm",
  className,
  circle = false,
  color = "red",
  children,
  href,
}) => {
  const props = {
    className: classNames(styles.pill, className, styles[size], {
      [styles.circle]: circle,
      [styles.button]: !!href,
    }),
    style: {
      backgroundColor: color ? `var(--color-${color.toLowerCase()}-transparent)` : "var(--color-bg-200)",
      color: color ? `var(--color-${color.toLowerCase()})` : "var(--color-fg-200)",
    },
  };

  if (!!href) {
    return (
      <Link href={href}>
        <a {...props}>{children}</a>
      </Link>
    );
  } else {
    return <div {...props}>{children}</div>;
  }
};

export default Pill;
